import { StyleContextResponse } from './types';
import { CustomObject } from '../../types';

export function getStyleContextFromDOM(): Partial<StyleContextResponse> {
	const root = document.getElementById('root');

	return root === null || typeof root.dataset.styleContext === 'undefined'
		? {}
		: (JSON.parse(root.dataset.styleContext) as CustomObject);
}
